export const WAITINGTIME = [1, 5, 8, 24, 36, 47];
